export enum AttendanceViewMode {
    Calendar = "Calendar",
    Table = "Table"
}

export enum AttendanceFastEntry {
    Absence = "Absence",
    Work = "Work"
}

export enum IntervalType {
    Work = "work",
    Absence = "absence",
    HolidayCompensation = "holidayCompensation",
    All = "all"
}

export type TDayMinutesMap = Record<number, number>;